<selfai-platform-schedule
  [schedules]="schedules$ | async"
  [workflows]="workflows$ | async"
  [presets]="presets$ | async"
  [isLoading]="loading$ | async"
  (backEvent)="onBack()"
  (submitEvent)="onSubmit($event)"
></selfai-platform-schedule>
